import { env } from '../../../../env';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import loginMessages from '../../../../messages/user-access/login.messages';
import { ErrorMessages } from '../../../../model/error';
import { LoginError, LoginRequestParams } from './login-types';

export const verifyLoginFields = (
  formValues: LoginRequestParams
): LoginError | undefined => {
  const { username } = formValues;

  if (!username) {
    return 'FILL_ALL_FIELDS';
  }
  return undefined;
};

export const messagesForLoginError = (error: LoginError): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
    case 'INVALID_CREDENTIALS':
      return {
        title: loginMessages.errorInvalidCredential,
      };
    case 'NOT_MIGRATED_USER':
      return {
        title:
          env.appModule === 'web'
            ? commonErrorMessages.errorNotMigratedUserWeb
            : commonErrorMessages.errorNotMigratedUserMobile,
      };
    case 'CODICE_UTENTE_ERRATO':
      return {
        title: commonErrorMessages.usernameNotValid,
      };
    case 'PASSWORD_ERRATA':
      return {
        title: loginMessages.errorInvalidCredential,
      };
    case 'FILL_ALL_FIELDS':
      return { title: loginMessages.errorTitleFillInAllFields };
    case 'INVALID_USER_CODE':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorInvalidUsername,
      };
    case 'TOO_MANY_REQUESTS':
      return { title: loginMessages.errorTooManyRequests };
  }
  return undefined;
};
